module.exports = __webpack_public_path__ + "img/prev.f40049f9.png";